import { useMemo } from 'react';
import { useSubscription } from 'react-relay';
import type { GraphQLSubscriptionConfig } from 'relay-runtime';

import type {
  PixAutomaticApprovedSubscription,
  PixAutomaticApprovedSubscription$variables,
} from './__generated__/PixAutomaticApprovedSubscription.graphql.ts';
import { PixAutomaticApproved } from './PixAutomaticApprovedSubscription.ts';

const usePixAutomaticApprovedSubscription = (
  variables: PixAutomaticApprovedSubscription$variables,
): void => {
  const pixAutomaticApproved = useMemo<
    GraphQLSubscriptionConfig<PixAutomaticApprovedSubscription>
  >(
    () => ({
      subscription: PixAutomaticApproved,
      variables,
    }),
    [variables],
  );

  useSubscription(pixAutomaticApproved);
};

export { usePixAutomaticApprovedSubscription };
